import { jsxs, jsx } from 'react/jsx-runtime';

const SvgNavCanvas = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M21 3H3v4.5h13.5V21H21V3Z" }), jsx("path", { fill: "#2D2E2E", d: "M14.25 12a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0ZM9.75 16.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" })] }));

export { SvgNavCanvas as default };
//# sourceMappingURL=NavCanvas.es.js.map
